export default __webpack_public_path__ + "static/media/CL05.0f8aa0c4.mp3";